import { ZodError, ZodSchema } from "zod";
import { loginSchema, registerBasicSchema, type LoginFormData, type RegisterBasicFormData } from "./auth.schema";

// Schema messages (auth.schema.ts) are translation KEYS, not display text —
// `t` is passed in from the calling hook (which has it via useLanguage())
// since this module is a plain utility, not a hook, and can't call t() itself.
type Translator = (key: string) => string;

const parseSchema = (schema: ZodSchema, data: unknown, t: Translator): Record<string, string> => {
  try {
    schema.parse(data);
    return {};
  } catch (err) {
    if (err instanceof ZodError) {
      const issues = err.issues;
      return Object.fromEntries(issues.map((e) => [e.path.join(".") || "general", t(e.message)]));
    }
    return {};
  }
};

/** Validates login form data. Returns fieldErrors map or empty object on success. */
export const validateLogin = (data: LoginFormData, t: Translator): Record<string, string> =>
  parseSchema(loginSchema, data, t);

/** Validates basic registration form data. Returns fieldErrors map or empty object. */
export const validateRegister = (data: RegisterBasicFormData, t: Translator): Record<string, string> =>
  parseSchema(registerBasicSchema, data, t);
